import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { Document } from '../_models/document';
import { MCRFolderElement } from '../_models/mcrfolderelement';
import { ISearchForm } from '../_models/search';
import { MCRVirtualFolder } from '../_models/mcrvirtualfolder';
import { McrfolderService } from '../_services/mcrfolder.service';
import { SearchService } from '../_services/search.service';
import { AlertService } from '../_services/alert.service';

@Component({
  selector: 'app-virtualfolder',
  templateUrl: './virtualfolder.component.html',
  styleUrls: ['./virtualfolder.component.scss']
})
export class VirtualfolderComponent implements OnInit {

  foldersList: MatTableDataSource<Observable<any>>;
  selection: SelectionModel<any>;
  initialData: Array<JSON> = [];
  width: String = "100";
  appError: String = "";
  hideDocList: Boolean = false;
  noSearchForms: boolean = false;

  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;

  events: string[] = [];
  opened: boolean;

  constructor(
    private mcrFolderSvc: McrfolderService,
    private cdref: ChangeDetectorRef,
    private alertService: AlertService
  ) { }

  virtualFolders: MCRVirtualFolder;
  virtualSubFolders: MCRVirtualFolder;
  disasterFolders: MCRVirtualFolder;
  pwFolders: MCRVirtualFolder;
  rfrFolders: MCRVirtualFolder;
  folderType: MCRVirtualFolder;
  documents: MCRVirtualFolder;
  fileType: String;
  level: string;
  searchResults: Array<JSON> = [];
  selectedRow: Array<JSON> = [];
  selectedForm: ISearchForm;
  selectedLocation: string;
  documentId: String;
  rowSelection: boolean = false;
  docCount: number;
  offset: number = 0;
  loadNext: boolean = false;
  order: number;
  folName: string;
  parent: string;
  loadPrevious: boolean = false;
  selectedDoc: string;
  allSearchForms: any
  noSearchResults: boolean = false;
  displayFolders: boolean = false;
  totalCount: number;

  public folderElements: Observable<MCRFolderElement[]>;
  currentRoot: MCRFolderElement;
  currentPath: string;
  canNavigateUp = false;

  ngOnInit(): void {
    var request = {
      "order_id": 0
    }
    this.mcrFolderSvc.getMCRFolders(request, this.offset)
      .subscribe(folders => {
        this.virtualFolders = folders;
        //console.log("folder: "+this.virtualFolders);
        this.displayFolders = true;
      }
      ),
      error => {
        this.alertService.error(error);
      };
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }


  getLocation(event, location) {
    this.selectedLocation = location;
    //console.log("Location:"+location);
    this.documentId = null;
    this.hideDocList = false;
    this.currentPath = this.pushToPath("", location);
    this.currentRoot = null;
    this.offset = 0;
    if (this.currentRoot) {
      this.currentRoot.name = 'root';
    }

    this.virtualSubFolders = null;
    this.folderElements = null;
    this.mcrFolderSvc.deleteRootElements();
    //console.log("Folder elements: "+this.folderElements);
    this.order = 1;
    this.folName = location;
    this.parent = 'root';
    this.generateFolderStructure(this.order, this.folName);

  }

  addFolders(folders: MCRVirtualFolder, parent: string, order: number) {
    if (folders.listView.length > 0) {
      var folder;
      if (order == 7) {
        folder = false;
      } else {
        folder = true;
      }
      for (var i = 0; i < folders.listView.length; i++) {
        console.log("Inside add folders - path "+this.currentPath);
        this.mcrFolderSvc.add({ name: folders.listView[i].value, isFolder: folder, parent: parent, order: order, filetype: folders.listView[i].filetype, versionNumber: folders.listView[i].version_num, documentId: folders.listView[i].id, path: this.currentPath + folders.listView[i].value + "/" });
      }
    }
    this.updateFileElementQuery();
    //this.foldersList = new MatTableDataSource(this.folderElements);
  }


  navigateToFolder(element: MCRFolderElement) {
    var request = null;
    this.currentRoot = element;
    this.offset = 0;
    this.order = element.order;
    this.folName = element.name;
    this.parent = this.currentPath;
    this.loadNext = false;
    this.loadPrevious = false;
    //console.log("Current Path: "+this.currentPath); 
    this.updateFileElementQuery();
    this.currentPath = this.pushToPath(this.currentPath, element.name);
    this.generateFolderStructure(this.order, this.folName);
    this.updateFileElementQuery();
    this.canNavigateUp = true;
  }

  generateFolderStructure(order, folName) {
    var request = null;
    console.log("order: " + order);
    if (order == 1) {
      this.level = "Applicant";
      request = {
        "order_id": 1,
        "location": folName
      }
      this.mcrFolderSvc.getMCRFolders(request, this.offset)
        .subscribe(folders => {
          if (folders["listView"]) {
            this.virtualSubFolders = folders;
            this.virtualSubFolders.listView = folders["listView"];
            this.setOffset(folders.count);
            //console.log("Subfolder: "+this.virtualSubFolders.listView);
            this.addFolders(this.virtualSubFolders, 'root', 2);
          }

        });
    }

    if (order == 2) {
      this.level = "Disaster";
      request = {
        "order_id": 2,
        "location": this.virtualSubFolders.location,
        "applicant": folName
      }
      this.mcrFolderSvc.getMCRFolders(request, this.offset)
        .subscribe(folders => {
          this.disasterFolders = folders;
          this.setOffset(folders.count);
          //console.log("Subfolder: "+this.disasterFolders.listView);
          this.addFolders(this.disasterFolders, this.currentPath, 3);
        }

        );

    }
    if (order == 3) {
      this.level = "PW";
      request = {
        "order_id": 3,
        "location": this.disasterFolders.location,
        "applicant": this.disasterFolders.applicant,
        "disasterid": folName
      }
      this.mcrFolderSvc.getMCRFolders(request, this.offset)
        .subscribe(folders => {
          this.pwFolders = folders;
          this.setOffset(folders.count);
          this.addFolders(this.pwFolders, this.currentPath, 4);
        }

        );

    }

    if (order == 4) {
      this.level = "RFR";
      request = {
        "order_id": 4,
        "location": this.pwFolders.location,
        "applicant": this.pwFolders.applicant,
        "disasterid": this.pwFolders.disaster_id,
        "pwid": folName
      }
      this.mcrFolderSvc.getMCRFolders(request, this.offset)
        .subscribe(folders => {
          this.rfrFolders = folders;
          this.setOffset(folders.count);
          this.addFolders(this.rfrFolders, this.currentPath, 5);
        }

        );
    }

    if (order == 5) {
      this.level = "Type";
      this.folderType = {
        "count": 2,
        "offset": 0,
        "limit": 1000,
        "location": this.rfrFolders.location,
        "applicant": this.rfrFolders.applicant,
        "disaster_id": this.rfrFolders.disaster_id,
        "pw_id": this.rfrFolders.pw_id,
        "rfr_id": folName,
        "listView": [
            {
                "value": "Content_Files",
                "id":"1",
                "filetype":"folder",
                "version_num" :1

            },
            {
              "value": "Summary_Files",
              "id":"1",
              "filetype":"folder",
              "version_num" :1

          }
        ]
    }
      //console.log("folder type "+JSON.stringify(this.folderType)); 
      this.addFolders(this.folderType, this.currentPath,6);

    }

    if (order == 6) {
      this.level = "Documents";
      if(folName === "Content_Files") {
        this.fileType = "application/pdf";
      } else {
        this.fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      }
      request = {
        "order_id": 5,
        "location": this.folderType.location,
        "applicant": this.folderType.applicant,
        "disasterid": this.folderType.disaster_id,
        "pwid": this.folderType.pw_id,
        "rfrid": this.folderType.rfr_id,
        "filetype": this.fileType
      }
      this.mcrFolderSvc.getMCRFolders(request, this.offset)
        .subscribe(folders => {
          this.documents = folders;
          this.setOffset(folders.count);
          this.addFolders(this.documents, this.currentPath, 7);
        }

        );

    }

  }

  navigateUp() {
    if (this.currentRoot && this.currentRoot.parent === 'root') {
      this.currentRoot = null;
      this.canNavigateUp = false;
      this.updateFileElementQuery();
    } else {
      this.currentRoot = this.mcrFolderSvc.get(this.currentRoot.parent);
      this.updateFileElementQuery();
    }
    this.currentPath = this.popFromPath(this.currentPath);
  }

  setOffset(count) {
    this.totalCount = count;
    //console.log("Count " + this.totalCount);
    if (this.totalCount > (this.offset + 1000)) {
      this.loadNext = true
    }
    if (this.offset >= 1000) {
      this.loadPrevious = true
    }
    //console.log(this.offset);
  }


  updateFileElementQuery() {
    this.folderElements = this.mcrFolderSvc.queryInFolder(this.currentRoot ? this.currentRoot.path : 'root');
    //console.log("folder elem"+JSON.stringify(this.folderElements));
  }

  pushToPath(path: string, folderName: string) {
    let p = path ? path : '';
    p += `${folderName}/`;
    return p;
  }

  popFromPath(path: string) {
    let p = path ? path : '';
    let split = p.split('/');
    split.splice(split.length - 2, 1);
    p = split.join('/');
    return p;
  }

  getDocDetails(element: MCRFolderElement, drawer) {
    if (drawer.opened) {
      drawer.toggle();
    }
    //console.log("Doc details"+element);
    this.rowSelection = true;
    this.hideDocList = true;
    this.selectedDoc = element.documentId;
    // this.selectedDoc.categoryId = 1;
    // this.selectedDoc.VersionNumber = element.versionNumber;
    // console.log("version number"+this.selectedDoc.VersionNumber);
  }

  trackByIndex(index, item) {
    return item.id;
  }

  next() {
    this.offset = this.offset + 1000;
    this.mcrFolderSvc.deleteElementsByParent(this.parent);
    this.generateFolderStructure(this.order, this.folName);
    this.updateFileElementQuery();
  }

  previous() {
    this.offset = this.offset - 1000
    this.generateFolderStructure(this.order, this.folName);
    this.updateFileElementQuery();
  }


  onHideDocList(hide: boolean) {
    //console.log("inside emit");
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.drawerContainer.open();
    }
  }


}
